import { render, staticRenderFns } from "./apply_role.vue?vue&type=template&id=58bb684a&scoped=true&"
import script from "./apply_role.vue?vue&type=script&lang=ts&"
export * from "./apply_role.vue?vue&type=script&lang=ts&"
import style0 from "./apply_role.vue?vue&type=style&index=0&id=58bb684a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb684a",
  null
  
)

export default component.exports